// Define initial state
const initialState = {
    roleplay_id: null,
    roleplayDescription: null,
    selectedInfo: {}
  };
  
  // Define action types
  const SELECT_ROLEPLAY = 'SELECT_ROLEPLAY';
  
  // Define reducer function
  const selectedRoleplayReducer = (state = initialState, action) => {
    switch (action.type) {
      case SELECT_ROLEPLAY:
        return {
          ...state,
          roleplay_id: action.payload.roleplay_id,
          roleplayDescription: action.payload.roleplayDescription,
          selectedInfo: action.payload.selectedInfo,
          repeatRoleplay: action.payload.repeatRoleplay
        };
      default:
        return state;
    }
  };


// Action creators
const setRoleplayInfo = (payload) => ({
  type: SELECT_ROLEPLAY,
  payload: payload
});


export { setRoleplayInfo };
export default selectedRoleplayReducer;
  